<template>
  <div class="app">
    <div class="d-flex h-100 justify-content-center align-items-center">
      <div class="mx-auto app-login-box col-md-8">
        <div class="mb-3 d-flex align-items-center justify-content-center">
          <img v-show="temLogoClienteNaSessao" :src="logoCliente" alt="" width="200" class="tenant-logo brand-image mt-1 ml-3 mr-3"/>
          <img alt="logo" :src="obterLogo" width="200" class="office-logo brand-image img-fluid">
        </div>
        <div class="modal-dialog w-100 mx-auto">
          <div class="modal-content">
            <div class="modal-body">
              <div class="h5 modal-title text-center">
                <h4 class="mt-2">
                  <div v-if="flags.processando">Concluindo a entrada,</div>
                  <span v-if="flags.processando">Por favor aguarde...</span>
                  <div v-if="flags.processando" class="divLoginSpinner mb-3">
                    <b-spinner class="ml-2" variant="danger"></b-spinner>
                  </div>
                  <div v-if="!flags.processando" class="avisoDanger mensagemAlerta">{{mensagemErro}}</div>
                </h4>
              </div>
              <div v-if="!flags.processando" id="acesso" class="mt-2 text-center">
                <router-link class="linkOutroEscritorio textos" :to="{name: 'login'}">
                  <span>Voltar para o login</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SsoRetorno from './js/ssoRetorno'
export default SsoRetorno
</script>

<style scoped>
@import "./scss/login.scss";
</style>
